import React from "react";
import { capitalizeSentence, getRemarkText } from "../utils/miscutils";


export default function BillRemarks({ bill }) {
  const billRemark = capitalizeSentence(getRemarkText(bill?.billRemarks));
  const billRemarkDescription = capitalizeSentence(
    getRemarkText(bill?.billRemarkDescription),
  );
  const legacyRemark = capitalizeSentence(getRemarkText(bill?.remarks));
  const childRemarks = Array.isArray(bill?.billSubRemarks)
    ? bill.billSubRemarks
        .map(getRemarkText)
        .filter(Boolean)
        .map(capitalizeSentence)
    : [];
  const hasNewRemarks = Boolean(billRemark);

  if (!hasNewRemarks) {
    return legacyRemark ? <p>{legacyRemark}</p> : "N/A";
  }

  return (
    <ul className="m-0 list-none p-0">
      <li className="relative wrap-break-word pl-4 text-base font-medium leading-6 text-text-primary before:absolute before:left-0 before:top-[0.55em] before:size-1.75 before:rounded-full before:bg-text-primary">
        {billRemark}
      </li>
      {childRemarks.map((remark, index) => (
        <li
          key={`${remark}-${index}`}
          className="relative mt-1 ml-4.5 wrap-break-word pl-3.5 text-sm font-light leading-5 text-text-primary before:absolute before:left-0 before:top-[0.55em] before:size-1.5 before:rounded-full before:bg-bullet-secondary"
        >
          {remark}
        </li>
      ))}
      {billRemarkDescription && (
        <li className="mt-2 wrap-break-word text-sm font-light leading-5 text-text-secondary">
          <span className="font-medium">Note: </span>
          {billRemarkDescription}
        </li>
      )}
    </ul>
  );
}
